var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.9993L21.223 16.4813C21.2983 16.5314 21.3858 16.5601 21.4761 16.5645C21.5664 16.5688 21.6563 16.5485 21.736 16.5058C21.8157 16.4631 21.8824 16.3996 21.9289 16.322C21.9754 16.2445 22 16.1557 22 16.0653V7.86929C22 7.78131 21.9768 7.69489 21.9328 7.61874C21.8887 7.54259 21.8253 7.47941 21.7491 7.43559C21.6728 7.39176 21.5863 7.36884 21.4983 7.36914C21.4103 7.36944 21.324 7.39295 21.248 7.43729L16 10.4993",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H14C15.1046 18 16 17.1046 16 16V8C16 6.89543 15.1046 6 14 6Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.1c50b210300ea3460b58b0e0e9eaef92.svg";
export { ForwardRef as ReactComponent };